import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Typography from "../../../../Typography";

import { ReactComponent as CloseIcon } from "../../../../../build/images/close-circle.svg";
import { ReactComponent as ArrowBackIcon } from "../../../../../build/images/arrow_back.svg";
import { ReactComponent as MessageComment } from "../../../../../build/images/nps-dashboard-icons/messagecomment.svg";

const CaseDealing = ({
  userHistoryDrawer,
  treatmentData,
  onCloseDrawer,
  caseId,
}) => {
  const userReducer = useSelector((state) => state.informationusers);
  const ServiceURL = useSelector((state) => state.serviceurl);

  let url_iframe = "";

  if (ServiceURL.length !== 0) {
    let ArrayServiceURL = "";

    if (userReducer.nameauth === "IngDesk") {
      ArrayServiceURL = ServiceURL.filter(
        (url) => url.typeofcrm === "IngDesk" && 1 === url.iddirection
      );
      if (ArrayServiceURL.length !== 0) {
        url_iframe = ArrayServiceURL[0].param;
      }
    }
  }

  if (userReducer.nameauth === "IngDesk") {
    return (
      <div
        className={`user-history-container ${
          userHistoryDrawer ? "" : "closed"
        }`}
      >
        <header className="user-history-container__header">
          <div>
            <ArrowBackIcon onClick={onCloseDrawer} />

            <Typography.H1 color="blue-selected-4" weight={700}></Typography.H1>
          </div>

          <button
            className="user-history-container__header__close"
            onClick={onCloseDrawer}
          >
            <CloseIcon />
          </button>
        </header>

        <main className="user-history-container__content">
          <iframe
            frameBorder="0"
            allow="camera;microphone;clipboard-write"
            src={`${url_iframe}/externo/${
              caseId ? "casos/" + caseId : "criar-casos"
            }?login-master=ingenium&login-user=${
              userReducer.username
            }&password-master=52e9f8a1500604b372a5c0908d93ee5f&destination=${
              treatmentData.numero_cliente
            }&filters-allow=true&dealing=true`}
            style={{ height: "100%", width: "100%" }}
            name="iframe_dealing"
            title="Iframe Dealing"
          ></iframe>
        </main>
      </div>
    );
  } else {
    return (
      <div
        className={`user-history-container ${
          userHistoryDrawer ? "" : "closed"
        }`}
      >
        <header className="user-history-container__header">
          <div>
            <ArrowBackIcon onClick={onCloseDrawer} />

            <Typography.H1 color="blue-selected-4" weight={700}></Typography.H1>
          </div>

          <button
            className="user-history-container__header__close"
            onClick={onCloseDrawer}
          >
            <CloseIcon />
          </button>
        </header>

        <main className="user-history-container__content">
          <div
            style={{
              textAlign: "center",
              gap: "8px",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <MessageComment />
            Você não tem permissão para acessar esta tela. Por favor, entre em
            contato com o administrador do sistema para obter assistência.
          </div>
        </main>
      </div>
    );
  }
};

export default CaseDealing;
